import { webApi } from '@mi-front/api-clients';
import { Box, SxProps, Theme } from '@mui/material';
import { FRAGMENT_CARD_PADDING_X } from '../constants';
import { FragmentCardCreator } from './FragmentCardCreator';
import { FragmentCardRelativeTime } from './FragmentCardRelativeTime';
import { FragmentCardTags } from './FragmentCardTags';

const footerSx = {
  px: FRAGMENT_CARD_PADDING_X,
  pb: 1.5,
  pt: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexWrap: 'wrap',
} as const;

/**
 * Shared footer for fragment cards: creator label, relative creation time,
 * and optional tag icon that shows tags in a popover on hover.
 */
export function FragmentCardFooter({
  fragment,
  sx,
}: {
  fragment: webApi.FragmentListItemDto;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={{ ...footerSx, ...sx }}>
      <FragmentCardCreator creator={fragment.creator} />
      <FragmentCardRelativeTime createdAt={fragment.createdAt} />
      <FragmentCardTags tags={fragment.tags as unknown as string[]} />
    </Box>
  );
}
